module.exports = __webpack_public_path__ + "static/media/user.16ab7a91.png";